import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { DefaultToast } from 'react-toast-notifications';
import { Icon } from 'ui';

const ToastCustom = ({ children, ...props }) => {
  function getIcon() {
    if (props && props.appearance === 'success') return 'success';
    if (props && props.appearance === 'error') return 'warning';
    if (props && props.appearance === 'info') return 'info-circle';
    if (props && props.appearance === 'warning') return 'warning';
  }

  function getColor() {
    if (props && props.appearance === 'success') return 'success';
    if (props && props.appearance === 'error') return 'red';
    if (props && props.appearance === 'info') return 'white';
    if (props && props.appearance === 'warning') return 'yellow';
  }

  return (
    <DefaultToast {...props}>
      <div
        className={clsx('toast', {
          'toast--success': props && props.appearance === 'success',
          'toast--error': props && props.appearance === 'error',
          'toast--info': props && props.appearance === 'info',
          'toast--warning': props && props.appearance === 'warning',
        })}
      >
        <Icon color={getColor()} name={getIcon()} /> {children}
      </div>
    </DefaultToast>
  );
};

ToastCustom.propTypes = {
  children: PropTypes.node,
  appearance: PropTypes.string,
};

export default ToastCustom;
